// App routes
import AthleteCalendarView from '../view/calendar/AthleteCalendarView';
import InvitedAthleteCalendarView from '../view/calendar/InvitedAthleteCalendarView';
import CalendarView from '../view/calendar/CalendarView';
import TeamCalendarView from '../view/calendar/TeamCalendarView';
import ProgramCalendarView from '../view/calendar/ProgramCalendarView';
import AthleteDesignerView from '../view/designer/AthleteDesignerView';
import InvitedAthleteDesignerView from '../view/designer/InvitedAthleteDesignerView';
import CalendarDesignerView from '../view/designer/CalendarDesignerView';
import TeamDesignerView from '../view/designer/TeamDesignerView';
import ProgramDesignerView from '../view/designer/ProgramDesignerView';
import AnalyticsCardsView from '../view/analytics/AnalyticsCardsView';
import ReadinessSurveyTeamView from '../view/analytics/readiness/ReadinessSurveyTeamView';
import ReadinessSurveyAthleteView from '../view/analytics/readiness/ReadinessSurveyAthleteView';
import TrainingSummaryTeamView from '../view/analytics/training-summary/TrainingSummaryTeamView';
import TrainingSummaryAthleteView from '../view/analytics/training-summary/TrainingSummaryAthleteView';
import LiftOneRepMaxView from '../view/analytics/lift-history/LiftOneRepMaxView';
import LiftHistoryView from '../view/analytics/lift-history/LiftHistoryView';
import LiftOneRepMaxHistoryView from '../view/analytics/lift-history/LiftOneRepMaxHistoryView';
import WorkingMaxHistoryView from '../view/analytics/working-max-history/WorkingMaxHistoryView';
import LiftProgressView from '../view/analytics/lift-progress/LiftProgressView';
import ComplianceView from '../view/analytics/compliance/ComplianceView';
import GymTools from '../view/nav/GymToolsView';
import NotificationsCenter from '../v5/notifications/components/NotificationsCenter';
import NotificationSettings from '../v5/notificationSettings/components/NotificationSettings';
import EmailSettingsView from '../v5/emailSettings/components/EmailSettingsView';
import MessagingHubView from '../v5/messaging/components/MessagingHubView';
import ShareLinks from '../view/my-store/components/ShareLinks';
import AttributionsReportingView from '../view/analytics/attributions/AttributionsReportingView';
import MarketplaceTransactionsView from '../view/analytics/marketplace/MarketplaceTransactionsView';
import MarketplaceOrgSummaryView from '../view/analytics/marketplace/MarketplaceOrgSummaryView';
import MarketplaceTrialsView from '../view/analytics/marketplace/MarketplaceTrialsView';
import HomeGuard from '../v5/home/components/HomeGuard';

export default {
    ANALYTICS: {
        CARDS: {
            component: AnalyticsCardsView,
            path: '/analytics'
        },
        LIFT_HISTORY: {
            component: LiftHistoryView,
            path: '/analytics/lift-history'
        },
        LIFT_ONE_REP_MAX: {
            component: LiftOneRepMaxView,
            path: '/analytics/lift-one-rep-max'
        },
        LIFT_ONE_REP_MAX_HISTORY: {
            component: LiftOneRepMaxHistoryView,
            path: '/analytics/lift-one-rep-max-history'
        },
        LIFT_PROGRESS: {
            component: LiftProgressView,
            path: '/analytics/lift-progress'
        },
        MARKETPLACE_TRANSACTIONS: {
            component: MarketplaceTransactionsView,
            path: '/analytics/marketplace-transactions'
        },
        MARKETPLACE_ORG_SUMMARY: {
            component: MarketplaceOrgSummaryView,
            path: '/analytics/marketplace-org-summary'
        },
        MARKETPLACE_ATTRIBUTIONS_FREE_TRIALS: {
            component: MarketplaceTrialsView,
            path: '/analytics/marketplace-trials'
        },
        MY_STORE_SHARE_LINKS: {
            component: ShareLinks,
            path: '/my-store/attribution-links'
        },
        MY_STORE_SHARE_LINKS_OLD_ROUTE_REDIRECT: {
            component: () => {
                window.location = '/my-store/attribution-links';
            },
            path: '/my-store/share-links'
        },
        MY_STORE_ANALYTICS_ATTRIBUTIONS: {
            component: AttributionsReportingView,
            path: '/my-store/analytics/attributions'
        },
        READINESS_SURVEY_TEAM: {
            component: ReadinessSurveyTeamView,
            path: '/analytics/readiness-survey-team'
        },
        READINESS_SURVEY_ATHLETE: {
            component: ReadinessSurveyAthleteView,
            path: '/analytics/readiness-survey-athlete'
        },
        TEAM_COMPLIANCE: {
            component: ComplianceView,
            path: '/analytics/compliance'
        },
        TRAINING_SUMMARY_TEAM: {
            component: TrainingSummaryTeamView,
            path: '/analytics/training-summary-team'
        },
        TRAINING_SUMMARY_ATHLETE: {
            component: TrainingSummaryAthleteView,
            path: '/analytics/training-summary-athlete'
        },
        WORKING_MAX_HISTORY: {
            component: WorkingMaxHistoryView,
            path: '/analytics/working-max-history'
        }
    },
    ATHLETE: {
        INVITE: {
            CALENDAR: {
                component: InvitedAthleteCalendarView,
                path: '/athlete/invite/:inviteId/:year/:month'
            },
            DESIGNER: {
                component: InvitedAthleteDesignerView,
                path: '/athlete/invite/:inviteId/:year/:month/:day'
            }
        },
        CALENDAR: {
            component: AthleteCalendarView,
            path: '/athlete/:athleteId/:year/:month'
        },
        DESIGNER: {
            component: AthleteDesignerView,
            path: '/athlete/:athleteId/:year/:month/:day'
        }
    },
    CALENDAR: {
        CALENDAR: {
            component: CalendarView,
            path: '/calendar/:programId/:year/:month'
        },
        DESIGNER: {
            component: CalendarDesignerView,
            path: '/calendar/:programId/:year/:month/:day'
        }
    },
    HOME: {
        component: HomeGuard,
        path: '/'
    },
    PROGRAM: {
        CALENDAR: {
            component: ProgramCalendarView,
            path: '/program/:programId'
        },
        DESIGNER: {
            component: ProgramDesignerView,
            path: '/program/:programId/:weekIndex/:dayIndex'
        }
    },
    TEAM: {
        CALENDAR: {
            component: TeamCalendarView,
            path: '/team/:programId/:year/:month'
        },
        DESIGNER: {
            component: TeamDesignerView,
            path: '/team/:programId/:year/:month/:day'
        }
    },
    GYMTOOLS: {
        component: GymTools,
        path: '/gymtools'
    },
    MESSAGING: {
        component: MessagingHubView,
        path: '/messaging'
    },
    NOTIFICATIONS: {
        component: NotificationsCenter,
        path: '/notifications'
    },
    NOTIFICATION_SETTINGS: {
        component: NotificationSettings,
        path: '/notification-settings'
    },
    PUBLIC_EMAIL_SETTINGS: {
        component: EmailSettingsView,
        path: '/email-settings',
        isPublic: true
    }
};



// WEBPACK FOOTER //
// ./src/state/routes.js